import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalHeader from "../header/subHeader";
import { RouteComponentProps } from "react-router-dom";
import { IProject, IApplicationState, IAuthenticationState } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";
import HeaderComponent from "../header/header";
import UserValidations from "./uservalidations";
import UserTransformations from "./usertransformations";
import nodejs from "../../../../assets/images/code-ico/nj.png";
import ruby from "../../../../assets/images/code-ico/ruby.png";
import js from "../../../../assets/images/code-ico/js.png";
import python from "../../../../assets/images/code-ico/python.png";
import c_sharp from "../../../../assets/images/code-ico/c_sharp.png";
import java from "../../../../assets/images/code-ico/java.png";
import UserFunctions from "./userFunctions";


export interface IAdvancedFeaturesProps1 extends RouteComponentProps, React.Props<GenerateEndpoint> {
    project: IProject;
   // path: object;
    actions: IProjectActions;
   // loggedInUser: IAuthenticationState;
    userDefinedActions: IUserDefinedActions;
  //  recentProjects: IProject[];
}

const textStyle = {
    color: 'green', fontStyle: 'italic'
}


function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
        recentProjects: state.recentProjects,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch)
    };
}

export interface IAdvancedFeaturesState {
    project: IProject;
    selectedFeature: string;
    codesList: any[];
    isActivePython: string,
    isActiveNode: string,
    isPython: boolean,
    isNode: boolean,
    isJava: boolean,
    isCHash: boolean,
    isJS: boolean,
    isRuby: boolean,
    isActiveJS: string,
    isActiveCHash: string,
    isActiveJava: string,
    isActiveruby: string
}


@connect(mapStateToProps, mapDispatchToProps)

export default class GenerateEndpoint
    extends React.Component<IAdvancedFeaturesProps1, IAdvancedFeaturesState> {
    
    public state: IAdvancedFeaturesState = {
        // selectedFeature: "GenerateEndPoint",
         selectedFeature: "functions",        
         project: this.props.project,
         isPython: true,
         isNode: false,
         isJava: false,
         isCHash: false,
         isJS: false,
         isRuby: false,
         isActivePython: 'active',
         isActiveNode: '',
         isActiveJS: '',
         isActiveCHash: '',
         isActiveJava: '',
         isActiveruby: '',
         codesList: [
             { title: "Python", value: "python", image: python, active: "active" },
             { title: "Node JS", value: "nodejs", image: nodejs, active: "" },
             { title: "Java", value: "java", image: java, active: "" },
             { title: "C#", value: "c_sharp", image: c_sharp, active: "" },
             { title: "Java Script", value: "js", image: js, active: "" },
             { title: "Ruby", value: "ruby", image: ruby, active: "" },
         ]
     };
 
 
     public nodeView = async (arg) => {
         if (arg == 'node') {
             this.setState({ isActiveNode: 'active', isActivePython: '', isActiveCHash: '', isActiveJS: '', isActiveJava: '', isActiveruby: '' })
             this.setState({
                 isPython: false, isNode: true
             })
         } else if (arg == 'python') {
             this.setState({ isActiveNode: '', isActivePython: 'active', isActiveCHash: '', isActiveJS: '', isActiveJava: '', isActiveruby: '' })
             this.setState({
                 isPython: true, isNode: false
             })
         } else if (arg == 'java') {
             this.setState({ isActiveNode: '', isActivePython: '', isActiveCHash: '', isActiveJS: '', isActiveJava: 'active', isActiveruby: '' })
             this.setState({
                 isPython: false, isNode: false, isJava: true
             })
 
         } else if (arg == 'c#') {
             this.setState({ isActiveNode: '', isActivePython: '', isActiveCHash: 'active', isActiveJS: '', isActiveJava: '', isActiveruby: '' })
             this.setState({
                 isPython: false, isNode: false, isJava: false, isCHash: true
             })
         } else if (arg == 'js') {
             this.setState({ isActiveNode: '', isActivePython: '', isActiveCHash: '', isActiveJS: 'active', isActiveJava: '', isActiveruby: '' })
             this.setState({
                 isPython: false, isNode: false, isJava: false, isCHash: false, isJS: true
             })
         } else {
             this.setState({ isActiveNode: '', isActivePython: '', isActiveCHash: '', isActiveJS: '', isActiveJava: '', isActiveruby: 'active' })
             this.setState({
                 isPython: false, isNode: false, isJava: false, isCHash: false, isJS: false, isRuby: true
             })
         }
     }
 
     public transformDataView = () => {
         if (this.state.isPython == true) {
             return (
                 <div className="end-point float-center">
                     <div className="ep-code active " >
                         <code>def transformation(data):</code>
                         <p><code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;try:</code></p>
                         <p style={textStyle}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#reading input data </p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data = json.loads(data)</p>
                         <p style={textStyle}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#Validation of dcap results in data.</p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data["transformationResults"] = {`<dict transformedoutput>`}</p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return data</p>
                         <p><code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;except Exception as e:</code></p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;error = {`{"error_msg" : "user defined transformation failed " + repr(e)}`}</p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data["transformationResults"] = error</p>
                         <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return data</p>
                     </div>
                     <div className="ep-code">
                         Java Code
                     </div>
                     <div className="ep-code">
                         end point code
                     </div>
                 </div>
             )
         }
         else if (this.state.isNode == true) {
             return (
                 <h2>In Future development node</h2>
             )
 
         } else if (this.state.isJava == true) {
             return (
                 <h2>In Future development java</h2>
             )
         } else if (this.state.isCHash == true) {
             return (
                 <h2>In Future development C#</h2>
             )
         } else if (this.state.isJS == true) {
             return (
                 <h2>In Future development JS</h2>
             )
         } else {
             return (
                 <h2>In Future development Ruby</h2>
             )
         }
 
     }
 
     public pythonCodeView = () => {
         if (this.state.isPython == true) {
             return (
                 <div>
                     <div className="end-point float-center" >
                         <div className="ep-code active">
                             <code>def validation(data):</code>
                             <p><code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;try:</code></p>
                             <p style={textStyle}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#reading input data </p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data = json.loads(data)</p>
                             <p style={textStyle}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#Validation of dcap results in data.</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;dcapValidationResults = []</p>
                             <p style={textStyle} >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#rule_1 = {`{"rule":"table is valid","status":"False"}`}</p>
                             <p style={textStyle}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Follow this format to construct each validation rule and status</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;dcapValidationResults.append(rule_1)</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;validatedoutput.update({`{"dcapValidationResults":dcapValidationResults}`})</p>
                             <p style={textStyle} >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#Validation of transformed results in data.</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;userDefinedValidationResults = []</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;userDefinedValidationResults.append(rule_1)</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;validatedoutput.update({`{"transformedValidationResults":userDefinedValidationResults}`})</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data["validationResults"] = {`<dict validatedoutput>`}</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return data</p>
                             <p><code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;except Exception as e:</code></p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;error = {`{"error_msg" : "user defined validations failed " + repr(e)}`}</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data["validationResults"] = error</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return data</p>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
 
 
                         </div>
                     </div>
                 </div>
             )
         }
         else if (this.state.isNode == true) {
             return (
                 <h2>In Future development node</h2>
             )
 
         } else if (this.state.isJava == true) {
             return (
                 <h2>In Future development java</h2>
             )
         } else if (this.state.isCHash == true) {
             return (
                 <h2>In Future development C#</h2>
             )
         } else if (this.state.isJS == true) {
             return (
                 <h2>In Future development JS</h2>
             )
         } else {
             return (
                 <h2>In Future development Ruby</h2>
             )
         }
 
     }
 
   // private onDeleteEndPointConfirm: React.RefObject<Confirm> = React.createRef();
    //private renameCanceled: () => void;

    public componentDidMount() {
        //const projectName = this.props.match.params["projectName"];
      //  this.getValidationsTransform(projectName);
    }

    public render() {
        //const { endpoint_name, endpoint, status, validationCheck } = this.state;
        const options = [
            { value: 'enable', label: 'Enable' },
            { value: 'disable', label: 'Disabled' },
        ];
        return (
            <>

                <section id="tabs" className="project-tab">
                    
                    <div className="tab-content" id="nav-tabContent">
                         

                        <div className="tab-pane fade show active" id="generate-user-endpoints" role="tabpanel" aria-labelledby="nav-home-tab" >

                            <div className="container">
                                <div className="row mt-2">

                                    <div className="col-md-12">
                                        <div className="advanced-card genarate-end-point">




                                            <section id="tabs">
                                                <nav>
                                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                        <a className="nav-item nav-link active" id="nav-validation-tab" data-toggle="tab" href="#nav-validation" role="tab" aria-controls="nav-validation" aria-selected="true">Validation</a>
                                                        <a className="nav-item nav-link" id="nav-transformation-tab" data-toggle="tab" href="#nav-transformation" role="tab" aria-controls="nav-transformation" aria-selected="false">Transformation</a>

                                                    </div>
                                                </nav>
                                                <div className="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
                                                    <div className="tab-pane fade show active" id="nav-validation" role="tabpanel" aria-labelledby="nav-validation-tab">

                                                        <div className="code">

                                                            <div className="code-ico">

                                                                <ul>
                                                                    {this.state.codesList &&
                                                                        // console.log(code , " >>>> code ")


                                                                        <ul>
                                                                            <li>
                                                                                {/* <a role="button" title="Python" className="cursor-pointer active"> <img src={python} /> </a> */}

                                                                                {/* <img id="image" title="Python" className={`cursor-pointer ${this.state.isActivePython}`} onClick={() => this.nodeView('python')} src={python}></img> */}
                                                                                <button title="Python" className={`cursor-pointer ${this.state.isActivePython}`} onClick={() => this.nodeView('python')}><img src={python} /></button>
                                                                            </li>
                                                                            <li>
                                                                                {/* <a href="#/" title="Node JS"> <img src={nodejs}   /> </a> */}
                                                                                <button title="Node JS" className={`cursor-pointer ${this.state.isActiveNode}`} onClick={() => this.nodeView('node')} ><img src={nodejs} /></button>
                                                                            </li>
                                                                            <li>
                                                                                {/* <a href="#/" title="Java"> <img src={java} /> </a> */}
                                                                                <button title="Java" className={`cursor-pointer ${this.state.isActiveJava}`} onClick={() => this.nodeView('java')} ><img src={java} /></button>
                                                                            </li>
                                                                            <li>
                                                                                {/* <a href="#/" title="C#"> <img src={c_sharp} /> </a> */}
                                                                                <button title="C#" className={`cursor-pointer ${this.state.isActiveCHash}`} onClick={() => this.nodeView('c#')} ><img src={c_sharp} /></button>
                                                                            </li>
                                                                            <li>
                                                                                {/* <a href="#/" title="Java Script"> <img src={js} /> </a> */}
                                                                                <button title="Java Script" className={`cursor-pointer ${this.state.isActiveJS}`} onClick={() => this.nodeView('js')} ><img src={js} /></button>
                                                                            </li>
                                                                            <li>
                                                                                {/* <a href="#/" title="Ruby"> <img src={ruby} /> </a> */}
                                                                                <button title="Ruby" className={`cursor-pointer ${this.state.isActiveruby}`} onClick={() => this.nodeView('ruby')} ><img src={ruby} /></button>
                                                                            </li>
                                                                        </ul>


                                                                    }


                                                                </ul>

                                                            </div>
                                                            <div>

                                                            </div>

                                                            <div>{this.pythonCodeView()} </div>


                                                        </div>



                                                    </div>
                                                    <div className="tab-pane fade" id="nav-transformation" role="tabpanel" aria-labelledby="nav-transformation-tab">



                                                        <div className="code">

                                                            <div className="code-ico">

                                                                <ul>
                                                                    <li>
                                                                        {/* <a role="button" title="Python" className="cursor-pointer active"> <img src={python} /> </a> */}
                                                                        <button title="Python" className={`cursor-pointer ${this.state.isActivePython}`} onClick={() => this.nodeView('python')}><img src={python} /></button>
                                                                    </li>
                                                                    <li>
                                                                        {/* <a href="#/" title="Node JS"> <img src={nodejs}   /> </a> */}
                                                                        <button title="Node JS" className={`cursor-pointer ${this.state.isActiveNode}`} onClick={() => this.nodeView('node')} ><img src={nodejs} /></button>
                                                                        {/* <button title="Node JS" onClick={this.nodeView} ></button> */}
                                                                    </li>
                                                                    <li>
                                                                        {/* <a href="#/" title="Java"> <img src={java} /> </a> */}
                                                                        <button title="Java" className={`cursor-pointer ${this.state.isActiveJava}`} onClick={() => this.nodeView('java')} ><img src={java} /></button>
                                                                    </li>
                                                                    <li>
                                                                        {/* <a href="#/" title="C#"> <img src={c_sharp} /> </a> */}
                                                                        <button title="C#" className={`cursor-pointer ${this.state.isActiveCHash}`} onClick={() => this.nodeView('c#')} ><img src={c_sharp} /></button>
                                                                    </li>
                                                                    <li>
                                                                        {/* <a href="#/" title="Java Script"> <img src={js} /> </a> */}
                                                                        <button title="Java Script" className={`cursor-pointer ${this.state.isActiveJS}`} onClick={() => this.nodeView('js')} ><img src={js} /></button>
                                                                    </li>
                                                                    <li>
                                                                        {/* <a href="#/" title="Ruby"> <img src={ruby} /> </a> */}
                                                                        <button title="Ruby" className={`cursor-pointer ${this.state.isActiveruby}`} onClick={() => this.nodeView('ruby')} ><img src={ruby} /></button>
                                                                    </li>
                                                                </ul>

                                                            </div>

                                                            {this.transformDataView()}

                                                        </div>



                                                    </div>

                                                </div>
                                            </section>
                                        </div>


                                    </div>

                                </div>
                            </div>

                        </div>
    
                    </div>
                </section>
            </>
        );
    }
   
}
